import { useMemo } from "react";

/**
 * 
 * @param {*} props
 * detail : string => object key of _details the field is part of
 * index : int => since _details is an array. This tells us to which this field belongs to
 * @returns 
 */
export const NumberField = (props) =>{
    const {fieldName, fieldConfig, onChange, detail, index, ...prop} = props;
    const handleFieldChange= (value, e) =>{
        try{
            value = parseFloat(value);
        }catch{
            value = null;
        }
        if(onChange)
            onChange(value, fieldName, {fieldConfig, detail, index, e});
    }
    
    const settings = useMemo(() => {
        return {
            Mandatory : false, 
            Type : "number",
            Value : null, 
            ...fieldConfig
        }
    }, [fieldConfig])
    return (
        <>
        <input 
            type= {settings.Type}
            name={fieldName}
            required={settings.Mandatory}
            key={fieldName}
            defaultValue={isNaN(settings.Value) ? "" : settings.Value}
            {...prop}
            onChange={(e) => {
                handleFieldChange(e.target.value, e);
            }}
            placeholder={settings.Trans?.Placeholder || ""}></input>
            </>
    )
}